import { PipeTransform, Pipe } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
    name: 'currencyCustom',
    pure: false
})
export class CurrencyCustomPipe implements PipeTransform {

    transform(value: any, type: any = '', locale: any = 'pt', prefix = ''): any {
        if(value=='' || value === null || value == 'NaN' || isNaN(value))
            return '';

        let suffix = '';

        if(type == 'short' && locale == 'pt'){

            value = Math.round(value);

            if(value < 1000000){
                suffix = ' mil';
                value = value / 1000;
            } else {
                suffix = ' mi';
                value = value / 1000000;
            }
           
        }

        if(typeof value !== 'string')
            value = value?.toString();

        if(value.indexOf(',') > -1)
            value = value.replace(',','.');

        switch(type){
            case 'type6':
                type = '0.6-6';
            break;
            case 'type4':
                type = '0.4-4';
            break;
            case 'short':
                type = '0.0-2';
            break;
            case 'type-m2':
                type = '0.0-0';
                suffix = 'm²';
            break;
            default:
                type = '0.2-2';
            break;
        }

        let v = new DecimalPipe(locale).transform(typeof value =='string'? Number(value) : value,type);

        if(type=='integer' && v.indexOf(',00'))
            v = v.replace(',00','');

        return (prefix!=''? '<span class="prefix">'+prefix+'</span>' : '') + v + (suffix!=''? '<span class="suffix">'+suffix+'</span>' : '');
   
    }
}